import { type } from 'arktype';
import { ref } from 'vue';

// TODO: Merge with the settings in cards-app
const ProductGid = type('string').pipe.try((s: string): number => {
  return Number.parseInt(s.replace('gid://shopify/Product/', ''), 10);
}, type('number'));

const UpsellCollection = type({
  label: 'string',
  products: ProductGid.array(),
}).pipe.try(
  (collection) => ({
    ...collection,
    slug: collection.label.replaceAll(' ', '-').toLowerCase(),
  }),
  type({
    label: 'string',
    products: 'number[]',
    slug: 'string',
  }),
);

const Settings = type({
  default_checked_tag: 'string',
  collection_groups: UpsellCollection.array(),
});

const parseSettings = type('string').pipe.try((s: string): Settings => JSON.parse(s), Settings);
export type Settings = typeof Settings.infer;

export function useSettings() {
  const settings = ref<Settings | null>(null);

  function refreshSettings() {
    const settingsScript = document.querySelector<HTMLScriptElement>('script#upsells-settings');
    const parsedSettings = parseSettings(settingsScript?.textContent ?? '{}');
    if (parsedSettings instanceof type.errors) {
      console.error(parsedSettings.flatProblemsByPath);
      settings.value = null;
    } else {
      settings.value = parsedSettings;
    }
  }

  return { settings, refreshSettings };
}
